export default __webpack_public_path__ + "static/media/logo-new.dbba448b.png";